import { Component } from '@angular/core';
import { Breadcrumb } from 'src/app/shared/breadcrumb/breadcrumb.model';
import { BreadcrumbService } from 'src/app/shared/breadcrumb/breadcrumb.service';
import { InfoMessage, Menu, pBMenus } from 'src/app/shared/all-routes';
import { ToastrService } from 'ngx-toastr';
import { GroupInvoicesService } from 'src/app/pages/group-invoices/group-invoices.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-group-invoices-table',
  templateUrl: './group-invoices-table.component.html'
})
export class GroupInvoicesTableComponentLookup {
  rows: any[] = [];
  temp: any[] = [];
  selectedRows: any[] = [];
  isAllSelected = false;
  queryParams: any = {};
  invoiceGroupData: any[] = [];
  searchText = "";
  groupInvoices: Menu | any = pBMenus.find(x => x.id == "GroupInvoices");
  page = 1;
  pageSize = 5;
  sortBy = 'InvoiceId';
  invoiceGroupId!: number;
  sortDir: 'asc' | 'desc' = 'asc';
  totalRecords = 0;
  selectedMap: { [key: string]: boolean } = {};
  constructor(
    private groupInvoicesService: GroupInvoicesService,
    private breadcrumbService: BreadcrumbService,
    private toastr: ToastrService,
    public activeModal: NgbActiveModal,    
    private route: ActivatedRoute,    
  ) { }

  ngOnInit(): void {
    let that = this;
    that.queryParams = that.route.snapshot.queryParams;
    that.route.queryParams.subscribe(params => {
    that.invoiceGroupId = Number(params['InvoiceGroupId']);
    that.loadData();
    });
    that.setBreadcrumbs();
  }

  loadData() {
    this.groupInvoicesService
  .getInvoiceGroupSelect(this.page, this.pageSize, this.sortBy, this.sortDir, this.searchText)
      .subscribe(res => {

        this.rows = res.Rows.map((x: any) => ({
          ...x,
          isSelected: !!this.selectedMap[x.InvoiceId]
        }));

        this.totalRecords = res.Total;

        this.updateSelectedRows();
      });
  }

  updateFilter(event: any) {
  this.searchText = event.target.value;
  this.page = 1;
  this.loadData();
  }

  getRowClass(row: any) {
    return row.isSelected ? 'row-selected' : '';
  }

  onCheckboxChange() {
    this.updateSelectedRows();
  }

  toggleAll() {
  this.rows.forEach(r => {
    r.isSelected = this.isAllSelected;

    if (r.isSelected) {
      this.selectedMap[r.InvoiceId] = true;
    } else {
      delete this.selectedMap[r.InvoiceId];
    }
  });

  this.updateSelectedRows();
}

  updateSelectedRows() {
    this.selectedRows = this.rows.filter(r => r.isSelected);

    this.rows.forEach(r => {
      if (r.isSelected) {
        this.selectedMap[r.InvoiceId] = true;
      } else {
        delete this.selectedMap[r.InvoiceId];
      }
    });

    this.isAllSelected =
      this.rows.length > 0 && this.rows.every(r => r.isSelected);
  }

 
  createInvoiceGroup() {
    const invoiceIds = Object.keys(this.selectedMap).map(id => Number(id));

    this.groupInvoicesService.assignInvoicesToGroup(invoiceIds)
      .subscribe(res => {
        this.toastr.success('Invoices grouped successfully.');
        this.selectedMap = {};
        this.loadData();
      },(error) =>{
        console.log(error)
      });
  }


  onSort(event: any) {
    const col = event.sorts[0];
    this.sortBy = col.prop;
    this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';

    this.loadData();
  }
  onPage(event: any) {
    this.page = event.page || event.offset + 1;
    this.loadData();
  }
  get globalSelectedCount(): number {
    return Object.keys(this.selectedMap).length;
  }
  onRowActivate(event: any) {
  if (event.type === 'click') {
    this.toggleRow(event.row);
  }
  }

  toggleRow(row: any) {
    row.isSelected = !row.isSelected;

    if (row.isSelected) {
      this.selectedMap[row.InvoiceId] = true;
    } else {
      delete this.selectedMap[row.InvoiceId];
    }

    this.updateSelectedRows();
  }
  select() {
      let that = this;
      const invoiceIds = Object.keys(this.selectedMap).map(id => Number(id));
      let data = {invoiceIds:invoiceIds , invoiceGroupId:this.invoiceGroupId}
      let selectedData :any = data;
      selectedData ? that.activeModal.close(selectedData) : that.toastr.warning(InfoMessage.SelectMessage, "Warning!");
    }
  
    close() {
      let that = this;
      that.activeModal.close();
    }
  setBreadcrumbs() {
    let that = this;
    let breadcrumbs: Breadcrumb[] = [];
    breadcrumbs.push({
      label: that.groupInvoices.grid.routeInfo.label,
      url: '',
      params: {}
    });
    this.breadcrumbService.set(breadcrumbs);
  }
}
